import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { getCommercialProducts } from './selectors';
// import axios from 'axios';

import {
  fetchSurveysSuccess,
  fetchSurveysFail,
  // fetchSurveySuccess,
  // fetchSurveyFail,
  submitSurveyFormSuccess,
  submitSurveyFormFail,
} from './actions';

import { FETCH_SURVEYS_REQUEST, /* FETCH_SURVEY_REQUEST, */ SUBMIT_SURVEY_FORM_REQUEST } from './actionTypes';

import { logout } from '../Auth/actions';
import { getOptions, processResponse } from '../../Utils/Utils';
import { API, fetchFromApi } from '../apis';
import { getSubmitBodyFromV1 } from './transform';

// const fetchSurveysUrl = () => '/api/v1/questionnaire';
// const fetchSurveyUrl = () => '/api/v1/questionnaire';
// const submitSurveyFormUrl = id => `/api/v1/questionnaire/${id}/submit`;

function* fetchSurveys() {
  // const params = {
  //   _fields: 'name,icon_name,code,description,sequence',
  // };
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.questionnaire.FETCH__ALL() /* , params */ })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(fetchSurveysSuccess({ data }));
      break;
    case 'fail':
      yield put(fetchSurveysFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

// function* fetchSurvey({ id }) {
//   const payload = { questionnaire: id };
//   const { response, error } = yield call(
//     fetchFromApi,
//     getOptions({ url: fetchSurveyUrl(id), method: 'POST', data: payload })
//   );
//   const { type, data, alerts } = processResponse({ response, error });

//   switch (type) {
//     case 'success':
//       yield put(fetchSurveySuccess({ data, id }));
//       break;
//     case 'fail':
//       yield put(fetchSurveyFail({ error: alerts, id }));
//       break;
//     case 'logout':
//       yield put(logout());
//       break;
//     default:
//       break;
//   }
// }

function* submitSurveyForm({ id, idPart, payload }) {
  const body = getSubmitBodyFromV1({ id, idPart, payload });
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.questionnaire.ACTION__COMPUTE(), method: 'POST', data: body })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(submitSurveyFormSuccess({ data, id, idPart, commercialProducts: yield select(getCommercialProducts) }));
      break;
    case 'fail':
      yield put(submitSurveyFormFail({ error: alerts, id, idPart }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* watchSurveys() {
  yield all([
    yield takeLatest(FETCH_SURVEYS_REQUEST, fetchSurveys),
    // yield takeLatest(FETCH_SURVEY_REQUEST, fetchSurvey),
    yield takeLatest(SUBMIT_SURVEY_FORM_REQUEST, submitSurveyForm),
  ]);
}

export default watchSurveys;
